import RestRepository from "../../infra/RestRepository";

export default class GoogleInstallRestRepo extends RestRepository {
  constructor() {
    super("/api/google-install");
  }
}
